import "./PrivacyInfoCarousel.scss";

import React from "react";
import Carousel from "nuka-carousel";
import { useWindowSize } from "../../../../../../../hooks/window-hooks";
import {
  SVG_ICONS,
  Svg,
} from "../../../../../../../components/__common/Svg/Svg";
import { Container } from "../../../../../../../components/Grid/Grid";
import { Typography } from "../../../../../../../components/__common/Typography/Typography";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../../../store";
import { LayoutState } from "../../../../../../../store/reducers/layout-reducer";
import { useTranslation } from "react-i18next";

const PrivacyInfoCarousel: React.FC = () => {
  const { isMobile } = useWindowSize();
  const { isRTL } = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );

  return (
    <div dir="ltr">
      <Carousel
        wrapAround={true}
        className="privacy-carousel"
        defaultControlsConfig={{
          containerClassName: "privacy-carousel__controls",
          pagingDotsContainerClassName: "privacy-carousel__dots",
          pagingDotsClassName: "privacy-carousel__dots__dot",
        }}
        renderCenterLeftControls={({ previousSlide }) => (
          <Svg
            icon={
              isMobile
                ? SVG_ICONS.CHEVRON_HUB_LEFT_MOBILE
                : SVG_ICONS.CHEVRON_HUB_LEFT
            }
            width={50}
            height={50}
            className="privacy-carousel__controls__button left"
            onClick={previousSlide}
          />
        )}
        renderCenterRightControls={({ nextSlide }) => (
          <Svg
            icon={
              isMobile
                ? SVG_ICONS.CHEVRON_HUB_RIGHT_MOBILE
                : SVG_ICONS.CHEVRON_HUB_RIGHT
            }
            width={50}
            height={50}
            className="privacy-carousel__controls__button right"
            onClick={nextSlide}
          />
        )}
        slideIndex={isRTL ? 2 : 0}
      >
        {isRTL ? <NoAds /> : <SeeData />}
        <DeleteData />
        {isRTL ? <SeeData /> : <NoAds />}
      </Carousel>
    </div>
  );
};

export default PrivacyInfoCarousel;

const SeeData: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="privacy-carousel__info download">
      <div className="text-container">
        <Typography variant="title1" className="privacy-carousel__info__title">
          {t("PRIVACY_HOME_BODY_INTRO_TITLE_TRANSPARENCY")}
        </Typography>
        <Typography
          variant="title2"
          weight="w500"
          className="privacy-carousel__info__details"
        >
          {t("PRIVACY_HOME_BODY_INTRO_EXP_TRANSPARENCY")}
        </Typography>
      </div>
    </Container>
  );
};

const DeleteData: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="privacy-carousel__info delete">
      <div className="text-container">
        <Typography variant="title1" className="privacy-carousel__info__title">
          {t("PRIVACY_HOME_BODY_INTRO_TITLE_CHOICE")}
        </Typography>
        <Typography
          variant="title2"
          weight="w500"
          className="privacy-carousel__info__details"
        >
          {t("PRIVACY_HOME_BODY_INTRO_EXP_CHOICE")}
        </Typography>
      </div>
    </Container>
  );
};

const NoAds: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="privacy-carousel__info opt-out">
      <div className="text-container">
        <Typography variant="title1" className="privacy-carousel__info__title">
          {t("PRIVACY_HOME_BODY_INTRO_TITLE_SAFETY")}
        </Typography>
        <Typography
          variant="title2"
          weight="w500"
          className="privacy-carousel__info__details"
        >
          {t("PRIVACY_HOME_BODY_INTRO_EXP_SAFETY")}
        </Typography>
      </div>
    </Container>
  );
};
